import { IProductType } from "@/typings/Props";
import styled from "styled-components";
import "aos/dist/aos.css";
import DetailInfoBox from "./DetailInfoBox";
import { media } from "@/styles/media";

export default function DetailInfo(product: IProductType) {
  return (
    <DetailInfoWrapper>
      <Area $disableOnMobile data-aos="slide-up" data-aos-offset="-600" data-aos-duration="1500" data-aos-easing="ease">
        <Img src={product.detailImage} alt="detail_image" />
      </Area>
      <Area>
        {product.detailInfo.map((info) => {
          return <DetailInfoBox key={info.id} {...info} />;
        })}
      </Area>
    </DetailInfoWrapper>
  );
}

const DetailInfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 2%;
  display: flex;

  ${media.tablet`
    flex-direction: column;
  `}
`;

const Area = styled.div<{ $disableOnMobile?: boolean }>`
  height: 100%;
  margin: 30px 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex: 1;
  gap: 20px;

  ${({ $disableOnMobile }) =>
    Boolean($disableOnMobile) &&
    `
      @media (max-width: 1300px) {
        display: none;
      }
    `}

  @media (max-width: 1300px) {
    margin: 0;
  }
`;

const Img = styled.img`
  max-width: 781px;
  width: 100%;
  margin: auto;
`;
